export const DASHBOARD_FILTERS = 'dashboard_filters';
export const TREE_NODE = 'tree_node';
export const TREE_TYPE = 'tree_type';
export const TREE_VIEW_BY = 'tree_view_by';
export const DAYS_BACK = 'days_back';
export const DATA_HEALTH_DAYS_BACK = 'data_health_days_back';
export const TEST_OVERVIEW_SIDEPANEL_TAB = 'test_overview_sidepanel_tab';
export const DWH_EDIT = 'dwh_edit';
export const ENV_SCHEDULE = 'env_schedule';
export const DWH_CREATE = 'dwh_create';
export const RULE_ID = 'rule_id';
export const INCIDENT_ID = 'incident_id';
export const INCIDENT_OVERVIEW_TAB = 'incident_overview_tab';
export const MERGE_INCIDENT_IDS_PARAM = 'merge_incident_ids';
export const MODEL_ID = 'model_id';
export const TEST_ID = 'test_id';
export const ROLE_ID = 'role_id';
export const GROUP_ID = 'group_id';
export const DRAWER_TYPE = 'drawer_type';
export const TABLE_ASSET_ID = 'table_asset_id';
export const ADD_TEST_DIALOG_MODE = 'add_test_dialog_mode';
export const TEST_RECOMMENDATIONS_DRAWER = 'test_recommendations_drawer';
export const ADD_TEST_RESOURCES_TABLE_SELECT_ALL =
  'add_test_resources_table_select_all';
export const CHAT_INCIDENT_ID = 'chat_incident_id';
export const COVERAGE_TABLE_SORT = 'coverage_table_sort';
export const LINEAGE_STREAM_DIRECTION = 'stream';
export const HOP_LIMIT = 'hop_limit';
export const DATA_HEALTH_FILTERS = 'data_health_filters';
export const INCIDENT_LIST_FILTERS = 'incident_list_filters';
export const INCIDENT_LIST_GROUP_BY = 'incident_list_group_by';
export const COVERAGE_TABLE_FILTERS = 'coverage_table';
export const LINEAGE_FILTERS = 'lineage_filters';
export const TEST_RESULTS_TABLE_FILTERS = 'test_results_table_filters';
export const TEST_RESULTS_TABLE_SORT = 'test_results_table_filters_sort';
export const TEST_RESULTS_GROUP_BY = 'test_results_group_by';
export const CATALOG_TABLE_FILTERS = 'catalog_table_filters';
export const CATALOG_TABLE_SORT = 'catalog_table_filters_sort';
export const TEST_OVERVIEW_TAB_EXECUTION_INFO = 'execution_info';
export const TEST_OVERVIEW_TAB_TEST_CONFIGURATION = 'test_configuration';
export const TEST_OVERVIEW_TAB_TEST_RESULTS = 'overview_test_results';
export const DASHBOARD_FILTER_VALUE_TAGS = 'tags';
export const DASHBOARD_FILTER_VALUE_OWNERS = 'owners';
export const TESTS_FILTER = 'tests';
export const ADD_TEST_RESOURCES_TABLE_FILTERS =
  'add_test_resources_table_filters';
export const NEW_VALUE = 'new';
export const PANEL_CONFIG_CHANGED = 'panel_config_changed';
export const SHOW_DISCARD_DIALOG = 'show_discard_dialog';
export const DATA_HEALTH_FILTER_TYPE = 'data_health_filter_type';
export const METRICS_TABLE_FILTERS = 'metrics_table_filters';
export const TEST_MANAGEMENT_TABLES_TABLE_FILTERS =
  'test_management_tables_table_filters';
export const TEST_MANAGEMENT_COLUMNS_TABLE_FILTERS =
  'test_management_columns_table_filters';
export const TEST_MANAGEMENT_CUSTOM_QUERY_TABLE_FILTERS =
  'test_management_custom_query_table_filters';
export const TEST_MANAGEMENT_PRS_TABLE_FILTERS =
  'test_management_prs_table_filters';
export const MODEL_RUNS_TABLE_FILTERS = 'model_runs_table_filters';
export const MODEL_RUNS_TABLE_SORT = 'model_runs_table_filters_sort';
export const TEST_RUNS_TABLE_FILTERS = 'test_runs_table_filters';
export const TEST_RUNS_TABLE_SORT = 'test_runs_table_filters_sort';
export const VIEW_ID = 'view_id';
export const PARENT_TEST_ID = 'parent_test_id';
